import { Controller } from "stimulus"
import 'devbridge-autocomplete/dist/jquery.autocomplete'

export default class extends Controller {
    static targets = [
        "doctorForeign",
        "chooseDoctor",
        "findDoctor",
        "doctorInput",
        "doctorIdInput",
        "changeDoctor",
        "doctorNotFound",
        "doctorHint",
        "doctorRppsGroup",
        "doctorRppsInput",
        "doctorNameInput",
        "doctorName",
        "notFoundLink",
        "searchDoctorSection",
        "manualDoctorSection",
        "suggestionsAnchor",
    ]

    form

    connect() {
        this.form = this.doctorInputTarget.closest('form');
        this.configureAutoComplete();
        this.configureFindDoctorInputs();
        this.configureManualDoctorRppsInputs();
        this.configureFindOrManual();
    }

    configureAutoComplete() {
        const options = {
            minChars: 3,
            maxHeight: 220,
            showNoSuggestionNotice: true,
            noSuggestionNotice: $(this.notFoundLinkTarget),
            appendTo: this.suggestionsAnchorTarget,
            serviceUrl: this.doctorInputTarget.dataset.url,
            dataType: 'json',
            paramName: 'q',
            deferRequestBy: 50,
            onSelect: (suggestion) => {
                this.doctorIdInputTarget.value = suggestion.data;
                this.doctorInputTarget.disabled = true;
                this.configureFindDoctorInputs();
            }
        }
        $(this.doctorInputTarget).autocomplete(options);
    }

    configureFindDoctorInputs() {
        if (this.doctorInputTarget.value) {
            this.doctorInputTarget.disabled = true;
            this.doctorHintTarget.style.display = 'none';
            this.doctorNotFoundTarget.style.display = 'none';
            this.changeDoctorTarget.style.display = 'block';
        } else {
            this.doctorHintTarget.style.display = 'block';
            this.doctorNotFoundTarget.style.display = 'block';
            this.changeDoctorTarget.style.display = 'none';
        }

    }

    configureManualDoctorRppsInputs() {
        this.doctorForeignTargets.forEach(foreign => {
            if (foreign.checked && foreign.value === 'true') {
                this.doctorRppsGroupTarget.style.display = 'none';
                this.findDoctorTarget.style.display = 'none';
                this.showManualDoctor();
            }
        })
    }

    configureFindOrManual() {
        if (!this.doctorInputTarget.value && this.doctorNameInputTarget.value) {
            this.showManualDoctor();
        } else {
            this.showFindDoctor();
        }
    }

    toggleDoctorForeign(event) {
        if (event.target.value === "true") {
            this.doctorRppsGroupTarget.style.display = 'none';
            this.findDoctorTarget.style.display = 'none';
            this.showManualDoctor();
            this.resetInputs();
        } else {
            this.doctorRppsGroupTarget.style.display = 'block';
            this.findDoctorTarget.style.display = 'block';
            this.showFindDoctor();
            this.resetInputs();
        }
    }

    setFindDoctor(event) {
        event.preventDefault();
        this.showFindDoctor();
        this.resetInputs();
    }

    enableAutocomplete() {
        $(this.doctorInputTarget).autocomplete('enable');
    }

    disableAutocomplete() {
        if (this.doctorIdInputTarget.value === "") {
            this.doctorInputTarget.value = null;
            $(this.form).resetClientSideValidations();
            $(this.form).enableClientSideValidations();
        }
        $(this.doctorInputTarget).autocomplete('disable');
    }

    setManualDoctor(event) {
        event.preventDefault();
        this.showManualDoctor();
        this.resetInputs();
    }

    showFindDoctor() {
        this.searchDoctorSectionTarget.style.display = 'block';
        this.manualDoctorSectionTarget.style.display = 'none';
    }

    showManualDoctor() {
        this.searchDoctorSectionTarget.style.display = 'none';
        this.manualDoctorSectionTarget.style.display = 'block';
    }

    resetInputs() {
        this.resetFindDoctor();
        this.resetManualDoctor();
        $(this.form).resetClientSideValidations();
        $(this.form).enableClientSideValidations();
    }

    resetFindDoctor() {
        $(this.doctorInputTarget).autocomplete('hide');
        this.doctorIdInputTarget.value = null;
        this.doctorInputTarget.value = null;
        this.doctorInputTarget.disabled = false;
        this.doctorInputTarget.focus();
        this.configureFindDoctorInputs();
        this.doctorInputTarget.focus();
    }

    resetManualDoctor() {
        this.doctorRppsInputTarget.value = null;
        this.doctorNameInputTarget.value = null;
    }
}